<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <div>
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Virtual Servers</h3>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          MCP server endpoints for your organization
        </p>
      </div>
      <Button variant="primary" size="sm" @click="emit('create')">New Server</Button>
    </div>

    <div v-if="store.isLoading" class="flex items-center justify-center py-12">
      <LoadingSpinner size="lg" />
    </div>

    <Alert v-else-if="store.error" variant="error">
      {{ store.error }}
    </Alert>

    <!-- eslint-disable-next-line asab-design-system/no-raw-button-card-markup -- dashed empty-state box, not a Card (no dashed/empty variant exists yet) -->
    <div
      v-else-if="store.virtualServers.length === 0"
      class="text-center py-12 bg-gray-50 dark:bg-gray-800/50 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-700"
    >
      <p class="text-sm text-gray-500 dark:text-gray-400">No virtual servers yet</p>
    </div>

    <div v-else class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <VServerTile
        v-for="server in store.virtualServers"
        :key="server.id"
        :server="server"
        @click="emit('select', server)"
        @edit="emit('edit', server)"
        @delete="emit('delete', server)"
        @manage-tools="emit('manage-tools', server)"
        @toggle-active="emit('toggle-active', server)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Alert, Button, LoadingSpinner } from '@asabdev/asab-ui';
  import { useMcpVServersStore } from '@/stores/mcpVServers';
  import type { VirtualServer } from '@/lib/mcp/types';
  import VServerTile from './VServerTile.vue';

  interface Emits {
    (e: 'create'): void;
    (e: 'select', server: VirtualServer): void;
    (e: 'edit', server: VirtualServer): void;
    (e: 'delete', server: VirtualServer): void;
    (e: 'manage-tools', server: VirtualServer): void;
    (e: 'toggle-active', server: VirtualServer): void;
  }

  const emit = defineEmits<Emits>();
  const store = useMcpVServersStore();
</script>
